import ReactJson from "react-json-view";
import { useState } from "react";
import {
  AccountingEventsGroup,
  DigitalBusinessDocument,
  DigitalCostDocument,
} from "../../types";
import DigitalBusinessDocumentView from "./document/DigitalBusinessDocumentView";
import { DigitalCostDocumentView } from "./document/DigitalCostDocumentView";
import { AccountingEventsView } from "./AccountingEventsView";
import {
  isDigitalBusinessDocument,
  isDigitalCostDocument,
} from "../../helpers/typeChecks";
import { JsonModal } from "../common/JsonModal";
import { useReactJsonProps } from "../../hooks/useReactJsonProps";

interface EventResultsProps {
  eventData:
    | AccountingEventsGroup
    | DigitalBusinessDocument
    | DigitalCostDocument;
}

export default function EventResults({ eventData }: EventResultsProps) {
  const [isJsonModalVisible, setIsJsonModalVisible] = useState(false);

  const jsonViewProps = useReactJsonProps({ sortKeys: true, collapsed: 3 });

  if ("accountingEvents" in eventData) {
    return (
      <>
        <AccountingEventsView
          accountingEvents={eventData.accountingEvents}
          jsonViewProps={jsonViewProps}
          modalHandler={() => setIsJsonModalVisible(true)}
        />
        <JsonModal
          title={`${eventData.pk} (AccountingEventsGroup)`}
          content={eventData}
          visible={isJsonModalVisible}
          onDismiss={() => setIsJsonModalVisible(false)}
        />
      </>
    );
  }

  if (isDigitalBusinessDocument(eventData)) {
    return (
      <>
        <DigitalBusinessDocumentView
          dbd={eventData}
          modalHandler={() => setIsJsonModalVisible(true)}
        />
        <JsonModal
          title={`${eventData.id} (DigitalBusinessDocument)`}
          content={eventData.body}
          visible={isJsonModalVisible}
          onDismiss={() => setIsJsonModalVisible(false)}
        />
      </>
    );
  }

  if (isDigitalCostDocument(eventData)) {
    return (
      <DigitalCostDocumentView dcd={eventData} jsonViewProps={jsonViewProps} />
    );
  }

  return <ReactJson src={eventData} {...jsonViewProps} />;
}
